import React from 'react';

/**
 * Button component with primary and secondary variants
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Button text or content
 * @param {string} [props.variant='primary'] - Button variant (primary or secondary)
 * @param {string} [props.className] - Additional CSS classes
 * @param {string} [props.href] - Optional URL for anchor buttons
 * @param {Function} [props.onClick] - Click handler
 * @param {string} [props.type='button'] - Button type attribute
 * @returns {React.ReactElement} Button component
 */
const Button = ({
  children,
  variant = 'primary',
  className = '',
  href,
  onClick,
  type = 'button',
  ...props
}) => {
  const baseClasses = 'inline-block w-full sm:w-auto text-center rounded-xl px-4 sm:px-6 py-2.5 sm:py-3 font-medium transition duration-200 focus:outline-none focus:ring-2 focus:ring-brand-blue-600';
  
  const variantClasses = {
    primary: 'bg-brand-blue-600 hover:bg-brand-blue-700 text-white shadow-lg',
    secondary: 'bg-transparent border-2 border-white text-white hover:bg-white/10 shadow-lg',
  };
  
  const buttonClasses = `${baseClasses} ${variantClasses[variant]} ${className}`;
  
  if (href) {
    return (
      <a href={href} className={buttonClasses} {...props}>
        {children}
      </a>
    );
  }
  
  return (
    <button 
      type={type} 
      className={buttonClasses} 
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
